import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { CustomTranslateLoader } from "../../../_services/custom.loader";
import { ESRIntgrationCompenent } from "./esr/esr.component";
import { CommonModule } from "@angular/common";
import { SvgIconModule } from "../../../_customComponent/Icons/_svg/app-jt-svg-icon.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { EsrVacancyApplicationStatusComponent  } from "./esr-vacancy-application-status/esr-vacancy-application-status.component";




@NgModule({
  declarations: [
    ESRIntgrationCompenent,
    EsrVacancyApplicationStatusComponent 
  ],
  imports: [
    CommonModule,
    SvgIconModule,
    NgbModule,
    TooltipModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [ESRIntgrationCompenent, EsrVacancyApplicationStatusComponent ],
})
export class DataMigrationIntegrationModule { }
